var React = require('react');

function StreamlineIconEvent (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("g",null,[React.createElement("path",{"d":"M10.46,19.81a1,1,0,0,1-.71-.29L7,16.79a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l2,2,6.1-6.11A1,1,0,0,1,18,12.71l-6.82,6.81A1,1,0,0,1,10.46,19.81Z","key":0}),React.createElement("path",{"d":"M21.5,3H18.75a.25.25,0,0,1-.25-.25V1a1,1,0,0,0-2,0V5.75a.76.76,0,0,1-.75.75h0A.76.76,0,0,1,15,5.75V3.5a.5.5,0,0,0-.5-.5H8.25A.25.25,0,0,1,8,2.75V1A1,1,0,0,0,6,1V5.75a.76.76,0,0,1-.75.75h0a.76.76,0,0,1-.75-.75V3.5A.5.5,0,0,0,4,3H2.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h19a2,2,0,0,0,2-2V5A2,2,0,0,0,21.5,3ZM21,22H3a.5.5,0,0,1-.5-.5V9.5A.5.5,0,0,1,3,9H21a.5.5,0,0,1,.5.5v12A.5.5,0,0,1,21,22Z","key":1})])));
}

StreamlineIconEvent.defaultProps = {"viewBox":"0 0 140 140"};

module.exports = StreamlineIconEvent;

StreamlineIconEvent.default = StreamlineIconEvent;
